import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m20.178 14.928-8.75 8.75A1.314 1.314 0 1 1 9.57 21.82L17.391 14 9.57 6.179a1.315 1.315 0 1 1 1.86-1.86l8.75 8.75a1.312 1.312 0 0 1-.003 1.86Z" />
  </svg>
);
export default SvgChevronRight;
